import React, { useState } from 'react'
import { addDoc, collection, serverTimestamp } from 'firebase/firestore'
import { db } from '../../../services/firebase'
import toast from 'react-hot-toast'

function ContactForm() {
  const [form, setForm] = useState({ name: '', email: '', subject: '', message: '' })
  const [loading, setLoading] = useState(false)

  const onChange = (e) => setForm({ ...form, [e.target.name]: e.target.value })

  const onSubmit = async (e) => {
    e.preventDefault()
    if (!form.name || !form.email || !form.subject || !form.message) {
      toast.error('Completa todos los campos')
      return
    }
    setLoading(true)
    try {
      await addDoc(collection(db, 'contacts'), {
        name: form.name,
        email: form.email,
        subject: form.subject,
        message: form.message,
        status: 'new',
        createdAt: serverTimestamp()
      })
      toast.success('Mensaje enviado')
      setForm({ name: '', email: '', subject: '', message: '' })
    } catch (err) {
      toast.error('Error al enviar')
    } finally { setLoading(false) }
  }

  return (
    <div className="grid grid-cols-1 lg:grid-cols-3 gap-8">
      <div className="lg:col-span-2 bg-white rounded-2xl shadow-sm p-6">
        <h3 className="text-xl font-semibold text-gray-900 mb-4">Envíanos un mensaje</h3>
        <form onSubmit={onSubmit} className="space-y-4">
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
            <input name="name" value={form.name} onChange={onChange} placeholder="Tu nombre" className="border rounded-md px-3 py-2" />
            <input name="email" value={form.email} onChange={onChange} type="email" placeholder="Tu email" className="border rounded-md px-3 py-2" />
          </div>
          <input name="subject" value={form.subject} onChange={onChange} placeholder="Asunto" className="border rounded-md px-3 py-2 w-full" />
          <textarea name="message" value={form.message} onChange={onChange} rows="4" placeholder="Tu mensaje..." className="border rounded-md px-3 py-2 w-full" />
          <button type="submit" className="btn-primary" disabled={loading}>{loading ? 'Enviando...' : 'Enviar'}</button>
        </form>
      </div>
      <div className="bg-white rounded-2xl shadow-sm p-6">
        <h4 className="text-lg font-semibold text-gray-900 mb-4">Contacto</h4>
        <p className="text-sm text-gray-600">Dkard</p>
        <p className="text-sm text-gray-600">admin@dkard.net</p>
        <p className="text-sm text-gray-600">+591 76903541</p>
      </div>
    </div>
  )
}

export default ContactForm
